import React, { useRef, useState, useEffect } from 'react';
import CompGridCompetition from '@components/grid/comp-grid-competition.js';
import CompFormCompetition from '@components/form/comp-form-competition.js';
import SearchForm from '@components/form/fragment/comp-fmt-search.js';
import ButtonForm from '@components/form/fragment/comp-fmt-button.js';
import {removeGrid, ApiSave, ApiCall} from '@assets/js/api/commonApi.js';

const CompetitionMng = (props) => {
    /****************************
     * Define required variables
    *****************************/
    const childRef = useRef();
    const childGridRef = useRef();
    const [params, setParams] = useState({});
    const [selectedRows, setSelectedRows] = useState({ ids: [], data: [] });
    const [cmptnAllowYn, setCmptnAllowYn] = useState('Y'); // 외부대회허용 여부 (기본값 Y)

    /**************************
     * useEffect - 페이지 진입 시 사용자 정보 조회
    ***************************/
    useEffect(() => {
        // 사용자 정보 조회
        ApiCall('/member/search/info', {}).then(res => {
            if (res && res.success && res.data && res.data.data) {
                const userInfo = res.data.data;
                // 외부대회허용 설정
                setCmptnAllowYn(userInfo.cmptnAllowYn || 'N');
            }
        });
    }, []);

    /**************************
     * Define button functions
    ***************************/
    const onNew = () => {
        childRef.current.modalToggle({mode: 'I'});
    }
    const onModify = (params) => {
        childRef.current.modalToggle({mode: 'M', ...params});
    }
    const onRemove = () => {
        if (selectedRows.length === 0) { alert('1건이상 선택해주세요.'); return; }
        const idsArray = [...selectedRows.ids];
        if (idsArray.length === 0) {
            alert('삭제할 항목을 선택해주세요.');
            return;
        }

        let trmntUseComptNmList = [];
        if (selectedRows.data) {
            selectedRows.data.map(item => {
                if (item.trmntUseCnt > 1) {
                    trmntUseComptNmList.push(item.comptnNm);
                }
            });
        }
        if (trmntUseComptNmList.length > 0) {
            alert('대진이 생성된 대회는 삭제 할 수 없습니다.\n(' + trmntUseComptNmList.join(', ') + ')');
            return;
        }

        const deleteParams = {
            deleteList: idsArray.map(rowId => {
                const parts = rowId.split('-');
                return {
                    mngCd: parts[0],
                    comptnCd: parts[1],
                };
            })
        };

        removeGrid('/sys/comptmng/remove/info', deleteParams, {
            msg: {
                confirm: '선택된 ' + idsArray.length + '개 항목을 삭제하시겠습니까?',
            }
        }).then(res => {
            if (res && res.success) {
                //clear selected rows grid.
                setSelectedRows(new Set());
                onGridSearch();
            }
        });
    }
    const onSaveMtmkg = () => {
        if (selectedRows.length === 0) { alert('한개의 대회정보를 선택해주세요.'); return; }
        const idsArray = [...selectedRows.ids];

        if (selectedRows.ids.length === 0) {
            alert('한개의 대회정보를 선택해주세요.');
            return;
        }
        if (idsArray.length !== 1) {
            alert('한개의 대회정보를 선택해주세요.');
            return;
        }
        if (!window.confirm('선택된 대회의 대진정보를 생성하시겠습니까?')) {
            return;
        }

        const selectedParams = idsArray.map(rowId => {
            const parts = rowId.split('-');
            return {
                mngCd: parts[0],
                comptnCd: parts[1],
            };
        });

        const opt = {
            message : '대진 정보가 정상적으로 생성 되었습니다.'
        }
        ApiSave('/sys/comptmng/save/mtmkg/info', selectedParams[0], opt).then(res => {
        });
    }
    const onRequestCmptnAllow = () => {
        // cmptnAllowYn이 Y이면 이미 승인된 상태이므로 요청 불가
        if (cmptnAllowYn === 'Y') {
            alert('이미 외부대회가 허용되었습니다.');
            return;
        }

        // 안내 메시지
        alert('무분별한 대회 정보 노출을 막기위하여 관리자 확인후에 승인하고 있습니다. 양해바랍니다.');

        // 외부대회허용 요청 API 호출
        ApiCall('/member/cmptnAllow/save', {}).then(res => {
            console.log('res', res);
            if (res && res.success) {
                alert('요청이 완료되었습니다.');
            } else {
                alert(res.message || '요청 처리 중 오류가 발생했습니다.');
            }
        });
    }
    
    const onGridSearch = () => {
        childGridRef.current.onGridSearch(params);
    }
    const onValChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
    *****************************/
    const formObj = {
        id : 'searchForm',
        params : {
            comptnNm : {
                id : 'comptnNm',
                label : '대회',
                maxLength : 100
            },
            strtDate : {
                id : 'strtDate',
                label : '대회시작일자(이상)',
                maxLength : 10
            },
            endDate : {
                id : 'endDate',
                label : '대회종료일자(이하)',
                maxLength : 10
            },
            useYn : {
                id: 'useYn', 
                label: '사용여부', 
                type: 'selectbox', 
                grpCd: 'GRP001', 
            },
        }
    }
    const buttonConfig = {
        fncButtons: [
            { id: 'mtmkg', label: '대진생성', className: 'btn-primary', onClick: onSaveMtmkg },
            // cmptnAllowYn이 'N'일 때만 '외부대회허용 요청' 버튼 표시
            ...(cmptnAllowYn === 'N' ? [{ id: 'requestAllow', label: '외부대회허용 요청', className: 'btn-warning', onClick: onRequestCmptnAllow }] : []),
        ],
        leftButtons: [
            { id: 'new', label: 'New', className: 'btn-success', onClick: onNew },
            { id: 'remove', label: 'Remove', className: 'btn-danger', onClick: onRemove }
        ],
        rightButtons: [
            { id: 'search', label: 'Search', className: 'btn-primary', onClick: onGridSearch }
        ]
    }

    return (
        <>
            {/* SearchForm */}
            <SearchForm formObj={formObj} onValChange={onValChange} onGridSearch={onGridSearch} params={params}/>

            {/* ButtonForm */}
            <ButtonForm buttonConfig={buttonConfig} />
            
            {/* Grid */}
            <CompGridCompetition ref={childGridRef} onChildClick={onModify} onSelectionChange={setSelectedRows}/>

            {/* Modal popup */}
            <CompFormCompetition ref={childRef} onGridSearch={onGridSearch} />
        </> 
    );
}

export default CompetitionMng;